import { render, staticRenderFns } from "./Sustainability.vue?vue&type=template&id=5ad5b0a8&scoped=true"
import script from "./Sustainability.vue?vue&type=script&lang=js"
export * from "./Sustainability.vue?vue&type=script&lang=js"
import style0 from "./Sustainability.vue?vue&type=style&index=0&id=5ad5b0a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad5b0a8",
  null
  
)

export default component.exports